import { Button } from '@blueprintjs/core';
import { BaoCaoThanhTra, DuLieuHeThong } from 'api';
import { DataTableKetQua } from 'components/data-table';
import { DropDown } from 'components/tt-forms/common';
import { header } from 'constants/table';
import { MasterLayout } from 'layout';
import { isEmpty } from 'lodash';
import React from 'react';
import ListItemThongKe from './ListItemThongKe.jsx';
import { API_URL } from 'constants/config';
import Axios from 'axios';

class Statistical extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      listNamThanhTra: [],
      namThanhTra: new Date().getFullYear(),
    };
  }

  onChange(name, e) {
    if (name == 'namThanhTra') {
      this.setState({
        namThanhTra: e.target.value,
      });
    }
  }

  getThongKe(params) {
    this.setState({
      tableLoading: true,
    });

    BaoCaoThanhTra.actions.getThongKe.request(null, params).then((res) => {
      if (res.data) {
        this.setState({
          data: res.data,
          tableLoading: false,
          search: false,
        });
      }
    });
  }

  handleSearch() {
    let params = {
      year: this.state.namThanhTra,
      statisticType: 'YEAR',
    };
    this.getThongKe(params);
  }

  handleExport() {
    const url = `${API_URL}/thong-ke-bao-cao/KHTH?year=${this.state.namThanhTra}&statisticType=YEAR`;
    Axios.get(url, {
      headers: {
        'Content-Type': 'application/octet-stream',
        Accept: 'application/octet-stream',
      },
      responseType: 'blob',
    })
      .then((response) => {
        const a = document.createElement('a');
        const url = window.URL.createObjectURL(response.data);
        a.href = url;
        a.download = 'thong-ke-bao-cao';
        a.click();
      })
      .catch((err) => {
        console.error('error', err);
      });
  }

  componentDidMount() {
    this.getNamThanhTra();
    this.handleSearch();
  }

  getNamThanhTra() {
    DuLieuHeThong.actions.getNamThanhTra.request(null, {}).then((res) => {
      const { data } = res;
      if (!isEmpty(data)) {
        this.setState({
          listNamThanhTra: data,
        });
      }
    });
  }

  renderTitle() {
    return (
      <div className='top-content'>
        <div className='left-content'>
          <p className='title-18'>
            <i className='tt tt-thanh-tra'></i>
            Thống kê kế hoạch, thực hiện thanh tra, kiểm tra
          </p>
        </div>
      </div>
    );
  }

  renderFilter() {
    return (
      <div className='row pl25 pr25 pt15 super-search'>
        <div className='col-20 no-gutter home-search-group'>
          <DropDown
            className='combobox-nam-thanh-tra pl5 pr5'
            label='Năm kế hoạch'
            selectedValue={this.state.namThanhTra}
            placeholder={null}
            onChange={this.onChange.bind(this, 'namThanhTra')}
            options={this.state.listNamThanhTra}
            valueName='ten'
            keyName='giaTri'
          />
        </div>
        <div className='col-16 btn-thongke'>
          <Button
            className={
              this.state.tableLoading
                ? this.state.search
                  ? 'btn-green tt-search btn-loading-inline'
                  : 'btn-green tt-search btn-disable'
                : 'btn-green tt-search'
            }
            text='Tìm kiếm'
            onClick={this.handleSearch.bind(this)}
          />
        </div>
        <div className='col-100'>
          <div className='col-90 p0 mb15'>
            <Button
              className='btn-green tt-export'
              text='Xuất Excel'
              onClick={this.handleExport.bind(this)}
            />
          </div>
        </div>
      </div>
    );
  }

  renderTable() {
    return (
      <div className='wrap-table clear-left'>
        <DataTableKetQua
          touchMove={true}
          header={header.thongKe}
          tableLoading={this.state.tableLoading}
        >
          <ListItemThongKe dataList={this.state.data} />
        </DataTableKetQua>
      </div>
    );
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <div
          className='center reception-container wrap-block'
          ref='thongKeBaoCao'
        >
          {this.renderTitle()}
          <div className='bottom-content thongke-content'>
            {this.renderFilter()}
            <div className='col-100 no-gutter pt5'>
              <span className='line-border'></span>
            </div>
            {this.renderTable()}
          </div>
        </div>
      </MasterLayout>
    );
  }
}

export default Statistical;



// WEBPACK FOOTER //
// ./src/components/modules/thong-ke/statistical.jsx